module.exports = __webpack_public_path__ + "static/protrait-circle-1-443cb8ecd3acfa34d4b44fac952d6069.png";